import React from "react";
import { Box, Skeleton } from "@mui/material";

// Reusable Text Skeleton Container Component
const TextSkeletonContainer = ({ width, height, lines }) => {
  // Generate an array of skeletons based on the number of lines
  const skeletonLines = Array.from({ length: lines }, (_, index) => (
    <Box key={index} sx={{ mb: 3 }}>
      {/* First Skeleton: Half the width */}
      <Skeleton variant="text" width={`calc(${width} / 2)`} height={height} />

      {/* Second Skeleton: Full width */}
      <Skeleton variant="text" width={width} height={height} sx={{ mt: 1 }} />
    </Box>
  ));

  return <>{skeletonLines}</>;
};

export default TextSkeletonContainer;
